module.exports = __webpack_public_path__ + "static/media/npa.87422ad9.svg";